<template>
    <div class="row">
        <div class="col-md-8 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">Dispute Documentation</h6>
                    <div class="d-flex tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
                <!--                <p v-if="company.company[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>-->
                <vue-good-wizard
                        :steps="steps"
                        class="mb-3"
                        :finalStepLabel="'End'"
                        :onNext="nextClicked"
                        :onBack="backClicked">
                    <div slot="page1">
                        <br>
                        <b-row style="text-align: justify-all;">
                            <b-col md="8"  style="text-align: justify-all;">
                                <h5 style="color: rgb(109, 6, 6);" >Dispute Management Process</h5>
                                <br>
                                <ul>
                                    <li>Log in with username and password</li>
                                    <li>Select “Submit Disputes” from the sidebar or Select “Disputes” and click on "New Dispute" at the top right corner</li>
                                    <li>Input “Session Id” or “Reference” and click on the search button to query transaction details</li>
                                    <li>Select input dispute type (pending dispute, settlement reversal, others)</li>
                                    <li>In the comment box, provide any other relevant information</li>
                                </ul>
                            </b-col>
                            <b-col md="4"  style="text-align: justify-all;">
                                <h5 style="color: rgb(109, 6, 6);">Features</h5>
                                <br>
                                <ul>
                                    <li>Log Dispute</li>
                                    <li>Re - open Dispute</li>
                                    <li>Check Transaction Status</li>
                                </ul>
                            </b-col>
                        </b-row>
                    </div>
                    <div slot="page2">
                        <table class="table mt-3">
                            <tr>
                                <th>#</th>
                                <th>Dispute Type</th>
                                <th>Description</th>
                                <th>Resolution</th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Pending Dispute</td>
                                <td>Beneficiary bank <span style="color: rgb(109, 6, 6);">wasn’t settled</span> for a transaction but value was given to the recipient.</td>
                                <td>Sender bank would be debited and the Beneficiary bank would be credited at the next session</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Settlement Reversal</td>
                                <td>Sender bank <span style="color: rgb(109, 6, 6);">was settled</span> but the beneficiary bank did not give value to the recipient.</td>
                                <td>The beneficiary bank would be debited and the sender bank credited.</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Others</td>
                                <td>Subject to description provided</td>
                                <td>Subject to description provided</td>
                            </tr>
                        </table>
                    </div>
                    <div slot="page3">
                        <table class="table mt-3">
                            <tr>
                                <th>#</th>
                                <th>Terms</th>
                                <th>Description</th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Inward</td>
                                <td>Incoming transfer from other banks to your Institution</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Outward</td>
                                <td>Outgoing transfers from your institution to other banks</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Sender Bank</td>
                                <td>Bank initiating a transaction</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>Beneficiary Bank</td>
                                <td>Bank receiving a transaction</td>
                            </tr>
                        </table>
                    </div>
                </vue-good-wizard>
            </div><!-- card -->
        </div>

        <div class="col-md-4 mg-t-10">
            <div class="card ht-100p">
                <div class="card-header d-flex align-items-center justify-content-between">
                    <h6 class="mg-b-0">New Dispute</h6>
                    <div class="d-flex tx-18">
                        <a href="" class="link-03 lh-0"><i class="icon ion-md-refresh"></i></a>
                        <a href="" class="link-03 lh-0 mg-l-10"><i class="icon ion-md-more"></i></a>
                    </div>
                </div>
                <!--                <p v-if="company.company[0] == null" align="center"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>-->
                <form  style="padding: 10px;">
                    <div class="form-row">
                        <div class="col-md-12">
                            <div class="position-relative form-group">
                                <label for="exampleEmail11" class="">Transaction Type <span style="color: darkred;">*</span></label>
                                <b-select v-model="model.disputeTrnType" >
                                    <b-select-option value="inward">inward</b-select-option>
                                    <b-select-option value="outward">outward</b-select-option>
                                </b-select>
                            </div>
                        </div>
                    </div>
                    <div class="form-row mb-2">
                        <div class="col-md-12">
                            <div class="position-relative form-group">
                                <label for="exampleEmail11" class="">Session ID <span style="color: darkred;">*</span></label>
                                <span class="row ml-1">
                                        <input v-model="model.disputeSessionId" id="exampleEmail11" placeholder="Session ID" type="text" class="form-control col-md-11">
<!--                                        <dynamic-modal-dispute-->
<!--                                                class="col-md-1 mt-2"-->
<!--                                                :loading="dispute.disputeLoading"-->
<!--                                                :data="dispute.logs"-->
<!--                                                :session-id="model.disputeSessionId"-->
<!--                                                :session-type="model.disputeTrnType"-->
<!--                                                style="cursor: pointer; font-size: 50px"-->
<!--                                                title="search Session Id"-->
<!--                                        ></dynamic-modal-dispute>-->
                                    </span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-12">
                            <label for="exampleEmail11" class="">Issue Type <span style="color: darkred;">*</span></label>
                            <b-select v-model="model.disputeIssueType" >
                                <b-select-option value="Pending Settlement">Pending Settlement</b-select-option>
                                <b-select-option value="Settlement Reversal">Settlement Reversal</b-select-option>
                                <b-select-option value="Other">Other</b-select-option>
                            </b-select>
                        </div>
                    </div>
                    <br>
                    <div class="form-row">
                        <div class="col-md-12">
                            <div  v-if="model.disputeIssueType === 'Other'"  class="position-relative form-group"><label for="exampleEmail1119" class="">Other Issue <span style="color: darkred;">*</span></label>
                                <input v-model="model.disputeIssueTypeOther" id="exampleEmail1119" placeholder="Other Issue" type="text" class="form-control">
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-md-12">
                            <div class="position-relative form-group"><label for="examplePassword111" class="">Comment <span style="color: darkred;">*</span></label>
                                <textarea rows="5" v-model="model.disputeComment" id="examplePassword111" placeholder="Comment" class="form-control"></textarea>
                            </div>
                        </div>
                    </div>
                    <p v-if="dispute.createLoading" align="right"><bar-loader  class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader></p>
                    <p v-else align="right"><button @click="createDispute()" type="button" style="background-color: #6d0606; border-color: #6d0606;" class="btn-shadow d-inline-flex align-items-center btn btn-success button">
                        Submit Dispute
                    </button></p>
                </form>
            </div><!-- card -->
        </div>
    </div><!-- row -->
</template>

<script>
    // import FlotChart from "../FlotChart";
    // Import component
    //import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';
    import {mapState} from 'vuex'
    export default {
        name: "TopCards",
        components:{
            //Loading
        },
        data(){
            return {
                officers:[],
                isLoading: true,
                fullPage: true,
                model:{
                    disputeSessionId:'',
                    disputeTrnType:'',
                    disputeComment:'',
                    disputeIssueType:'',
                    disputeIssueTypeOther:'',
                    disputeOrgId:''
                },
                steps: [
                    {
                        label: 'Features/Process',
                        slot: 'page1',
                    },
                    {
                        label: 'Appendix A',
                        slot: 'page2',
                    },
                    {
                        label: 'Appendix B',
                        slot: 'page3',
                    }
                ],
            };
        },
        methods: {
            // eslint-disable-next-line no-unused-vars
            nextClicked(currentPage) {
                //console.log('next clicked', currentPage)
                // if (currentPage >= this.steps.length-1)
                //     this.createOfficer()
                return true; //return false if you want to prevent moving to next page
            },
            // eslint-disable-next-line no-unused-vars
            backClicked(currentPage) {
                //console.log('back clicked', currentPage);
                return true; //return false if you want to prevent moving to previous page
            },
            async readOfficers(){
                await this.$store.dispatch("officer/updateOfficers", {
                    orgID: localStorage.orgID,
                    accID: localStorage.accID,
                    requestType: 'officer'
                }, {root: true})
            },
            showAlert(title, message) {
                const options = {title: title, size: 'sm'}
                this.$dialogs.alert(message, options)
                    // eslint-disable-next-line no-unused-vars
                    .then(res => {
                        //console.log(res) // {ok: true|false|undefined}
                    })
            },
            async createDispute(){

                if (this.model.disputeSessionId !== ''
                    && this.model.disputeTrnType !== ''
                    && this.model.disputeComment !== ''
                    && this.model.disputeIssueType !== ''
                )  {
                    // console.log(this.model);
                    if (this.model.disputeIssueType === 'Other') {
                        this.model.disputeIssueType = this.model.disputeIssueTypeOther
                    }
                    if (this.model.disputeIssueType === ''){
                        const options = {title: 'Error!', size: 'sm'}
                        this.$dialogs.alert('Empty field detected. Please fill fields', options)
                            // eslint-disable-next-line no-unused-vars
                            .then(res => {
                                //console.log(res) // {ok: true|false|undefined}
                            })
                    }else{
                        this.model.dialogs = this.$dialogs
                        this.model.disputeOrgId = this.company.company[0].orgID
                        await this.$store.dispatch("dispute/createDispute", this.model, {root: true})
                    }

                    // return
                }else{
                    let fields = ""
                    if (this.model.disputeSessionId === '') fields += ' Session Id,';
                    if(this.model.disputeTrnType === '') fields += ' Transaction Type,';
                    if(this.model.disputeComment === '') fields += ' Comment,';
                    if(this.model.disputeIssueType === '') fields += ' Issue,';
                    fields = fields.substr(0,fields.length-1);
                    const options = {title: 'Error!', size: 'sm'}
                    this.$dialogs.alert( fields+' must not be empty.', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        })
                }
            },
        },
        computed:{
            ...mapState([
                'dispute',
                'company',
                'officer'
            ])
        }
    }
</script>

<style scoped>
    @media only screen and (min-width: 900px) {
        .top-card {
            width: 103%;
        }
    }
    @media only screen and (min-width: 707px) and (max-width: 900px) {
        .top-card {
            width: 104%;
        }
    }

    @media only screen and (min-width: 517px)  and (max-width: 707px) {
        .top-card {
            width: 105%;
        }
    }

    @media only screen and (min-width: 451px)  and (max-width: 517px) {
        .top-card {
            width: 106%;
        }
    }

    @media only screen  and (max-width: 451px) {
        .top-card {
            width: 107%;
        }
    }
</style>